import { collection, getDocs, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { DBCollection } from '@/lib/utils/constants-shared';
import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch all people from Firestore
 */
export async function fetchPeopleFromDB(storage?: FirebaseStorage): Promise<Person[]> {
    async function fallback() {
        const db = getFirestore(getApp());
        const peopleCollection = collection(db, DBCollection.people);
        const snapshot = await getDocs(peopleCollection);

        return snapshot.docs.map(doc => {
            const data = doc.data() as FirebasePerson;
            return {
                id: doc.id,
                ...data
            } as Person;
        });
    }

    if (storage) {
        return await fetchCollectionFromStorage<Person>(
            storage,
            `bulk-data/${DBCollection.people}.json`,
            fallback
        );
    }

    return await fallback();
}

